// 26.1.10 Reflect.isExtensible(target)
var $export       = require('./_export')
  , anObject      = require('./_an-object')
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.reflect.is-extensible.js
// module id = 538
// module chunks = 58